import { RootState } from "../../../../../redux/store";
import * as constants from "./constants";

export const isItemsLoading = (state:RootState) => state.regions.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.regions.actionsLoading;
export const getItems = (state:RootState) => state.regions.items;
export const getItemsSelect = (state:RootState) => state.regions.dropDownItems;
export const getItemsSelectLoading = (state:RootState) => state.regions.dropDownLoading;

export const getItemsBillingSelect = (state:RootState) => state.regions.entitiesBillingSelect;
export const getItemsBillingSelectLoading = (state:RootState) => state.regions.entitiesBillingSelectLoading;


export const getItemsCount = (state:RootState) => state.regions.itemsCount;
export const getItemForEdit = (state:RootState) => state.regions.itemForEdit;
export const getError = (state:RootState) => state.regions.error;
export const getErrorAction = (state:RootState) => state.regions.errorAction
export const validationErrors = (state: RootState) => state.regions.validationErrors;